
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ApartmentTypesSection from './components/ApartmentTypesSection';
import ChallengesSection from './components/ChallengesSection';
import ProcessSection from './components/ProcessSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import BenefitsSection from './components/BenefitsSection';
import ComparisonSection from './components/ComparisonSection';
import MarketAnalysisSection from './components/MarketAnalysisSection';
import TitleCompanySection from './components/TitleCompanySection';
import TrackRecordSection from './components/TrackRecordSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '../../components/feature/Footer';
import GlobalNavbar from '../../components/feature/GlobalNavbar';

export default function SellApartmentsPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Sell Apartment Building El Paso | We Buy Multi-Family Properties Cash"
        description="Sell your apartment building or multi-family property fast for cash in El Paso. We buy duplexes, triplexes, and apartment complexes. No commissions, quick closing."
        keywords="sell apartment building El Paso, sell multi-family property, apartment complex buyers, sell duplex El Paso, multi-family cash buyers"
        canonical="/sell-apartments"
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Apartment Building Buying Service",
          "provider": {
            "@type": "RealEstateAgent",
            "name": "TREX RE LLC"
          },
          "areaServed": "El Paso, TX"
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <IntroSection />
      <ApartmentTypesSection />
      <ChallengesSection />
      <ProcessSection />
      <WhyChooseUsSection />
      <BenefitsSection />
      <ComparisonSection />
      <MarketAnalysisSection />
      <TitleCompanySection />
      <TrackRecordSection />
      <CaseStudiesSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
